import React from "react";
import { authPaymentTypes } from "../../../parent/data/auth-payment-types";
import Show from "../../../../../utils/show.component";

export const SkipAPayPopupButton = ({
  OtherAuthLoanOptions,
  AccountHash,
  IsOpenEndedLoan,
  LoanNumber,
  IsCreditOrExternalAccount,
  setPaymentInfo,
  selectPaymentType,
  callAuthGetSkipInfo,
  callSaveSkipDenialReasons,
  lastFour,
}) => {
  const isValidForSkips = () => {
    const isValid = OtherAuthLoanOptions.IsSkipAPayAllowed;

    return isValid;
  };

  const setSkipPaymentInfo = (declineMessageArray) => {
    if (declineMessageArray.length === 0) {
      // Use setPaymentInfo directly to skip the payment type selection modal
      // and directly set the parent paymentInfo state
      setPaymentInfo((state) => {
        return {
          ...state,
          // method: "BankAccount",
          loanId: AccountHash,
          type: authPaymentTypes.valid.EligibleSkip,
          isOpenEnded: IsOpenEndedLoan,
        };
      });
    } else {
      // Use selectPaymentType to open the modal and display the invalid skip message
      selectPaymentType(authPaymentTypes.invalid.IneligibleSkip, false);
    }
  };

  const onSkipClick = () => {
    window.scrollTo(0, 0);

    if (isValidForSkips()) {
      callAuthGetSkipInfo(LoanNumber, setSkipPaymentInfo);
    } else {
      callSaveSkipDenialReasons(["This type of loan does not qualify for Skip A Pay."]);

      selectPaymentType(authPaymentTypes.invalid.IneligibleSkip, false);
    }
  };

  return (
    <Show condition={!IsCreditOrExternalAccount}>
      <li>
        <button
          className="f12 mt-0 auth-card-popup-button"
          onClick={onSkipClick}
          data-e2e-id={"skipAPayButton-" + lastFour}
        >
          Skip A Pay
        </button>
      </li>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/popup-menu-buttons/skip-a-pay-popup-button.component.js